module.exports = __webpack_public_path__ + "img/ROROCCCO01160242.4d657334.png";